import React from 'react';
import {FormattedMessage} from 'react-intl';

import {Preferences} from 'mattermost-redux/constants';
import {PreferenceType} from 'mattermost-redux/types/preferences';

import SettingItemMax from 'components/setting_item_max';
import SettingItemMin from 'components/setting_item_min';

type Props = {
    active: boolean;
    currentUserId: string;
    savePreferences: (userId: string, preferences: PreferenceType[]) => Promise<{data: boolean}>;
    showUnreadCollapsedChannels: boolean;
    updateSection: (section: string) => void;
}

type State = {
    active: boolean;
    checked: boolean;
    isSaving: boolean;
}

export default class ShowUnreadsCategory extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            active: false,
            checked: false,
            isSaving: false,
        };
    }

    static getDerivedStateFromProps(props: Props, state: State) {
        if (props.active !== state.active) {
            if (props.active && !state.active) {
                return {
                    checked: props.showUnreadCollapsedChannels,
                    active: props.active,
                };
            }

            return {
                active: props.active,
            };
        }

        return null;
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            checked: e.target.value === 'true',
        });
    }

    handleSubmit = async () => {
        this.setState({isSaving: true});

        await this.props.savePreferences(this.props.currentUserId, [{
            user_id: this.props.currentUserId,
            category: Preferences.CATEGORY_SIDEBAR_SETTINGS,
            name: Preferences.SHOW_UNREAD_COLLAPSED_CHANNELS,
            value: this.state.checked.toString(),
        }]);

        this.setState({isSaving: false});

        this.props.updateSection('');
    }

    renderOn = () => {
        return (
            <FormattedMessage
                id='user.settings.sidebar.on'
                defaultMessage='On'
            />
        );
    }

    renderOff = () => {
        return (
            <FormattedMessage
                id='user.settings.sidebar.off'
                defaultMessage='Off'
            />
        );
    }

    renderDescription = () => {
        return this.props.showUnreadCollapsedChannels ? this.renderOn() : this.renderOff();
    }

    render() {
        const title = (
            <FormattedMessage
                id='user.settings.sidebar.showUnreadCollapsedChannelsTitle'
                defaultMessage='Show unread channels in a collapsed category'
            />
        );

        if (!this.props.active) {
            return (
                <SettingItemMin
                    title={title}
                    describe={this.renderDescription()}
                    section='showUnreadCollapsedChannels'
                    updateSection={this.props.updateSection}
                />
            );
        }

        return (
            <SettingItemMax
                title={title}
                inputs={
                    <fieldset>
                        <legend className='form-legend hidden-label'>
                            {title}
                        </legend>
                        <div className='radio'>
                            <label>
                                <input
                                    data-testid='showUnreadCollapsedChannelOn'
                                    type='radio'
                                    name='showUnreadCollapsedChannels'
                                    checked={this.state.checked}
                                    onChange={() => this.setState({checked: true})}
                                />
                                {this.renderOn()}
                            </label>
                            <br/>
                        </div>
                        <div className='radio'>
                            <label>
                                <input
                                    data-testid='showUnreadCollapsedChannelOff'
                                    type='radio'
                                    name='showUnreadCollapsedChannels'
                                    checked={!this.state.checked}
                                    onChange={() => this.setState({checked: false})}
                                />
                                {this.renderOff()}
                            </label>
                            <br/>
                        </div>
                    </fieldset>
                }
                submit={this.handleSubmit}
                saving={this.state.isSaving}
                updateSection={this.props.updateSection}
            />
        );
    }
}
